<template>
  <div>
    <ClientHeader :cid="cid" :sid="sid"/>
    <section class="client-gender">
      <div class="container">
        <h1 class="client-gender__title">Ваш пол:</h1>
        <router-link
          :to="`/company/${cid}/${sid}/client-service`"
          @click.native="setGender('male')"
          class="client-gender__link"
        >Мужчина</router-link>
        <router-link
          :to="`/company/${cid}/${sid}/client-service`"
          @click.native="setGender('female')"
          class="client-gender__link"
        >Женщина</router-link>
      </div>
    </section>
  </div>
</template>
<script>
import ClientHeader from "@/components/ClientHeader.vue";
import { mapState, mapActions } from "vuex";

export default {
  name: "client-gender",
  props: ["cid", 'sid'],
  components: {
    ClientHeader
  },
  computed: {
    ...mapState("client", ["currentSalonId"])
  },
  mounted() {
    this.clearGender();
    this.clearServiceInProgress()
  },
  methods: {
    ...mapActions("salons", ["fetchSalon"]),
    ...mapActions("client", ["selectGender", "clearGender", "clearServiceInProgress"]),
    async setGender(gender) {
      await this.selectGender({ salonId: this.currentSalonId, gender });
    }
  }
};
</script>
<style lang="sass">
// width
=r($width)
  @media only screen and (max-width: $width+ "px")
    @content

=rmin($width)
  @media only screen and (min-width: $width+ "px")
    @content

// height
=rh($height)
  @media only screen and (max-height: $height + "px")
    @content

=rhmin($height)
  @media only screen and (min-height: $height + "px")
    @content
// LAYOUT
$mobile-s: 375
$mobile: 568
$tablet: 767
$desktop: 992
$wide: 1336
$hd: 1440

// COLORS
$text-18: #181818
$text-36: #363636

// OPTIONS
$transitSpeed: .2s
$ease: ease-in-out

.client-gender
  .container
    height: calc(100vh - 70px)
    display: -webkit-flex
    display: -ms-flex
    display: flex
    flex-direction: column
    align-items: center
    justify-content: center
  &__title
    font-size: 24px
    font-weight: 500
    color: $text-36
    margin-top: 0
    margin-bottom: 50px
    text-align: center
  &__link
    display: table
    color: $text-36
    font-weight: 400
    font-size: 24px
    padding-bottom: 3px
    border-bottom: 1px solid transparent
    margin-bottom: 35px
    transition: all $transitSpeed
    &:hover
      border-color: $text-36
    &:last-child
      margin-bottom: 0

+r($mobile)
  .client-gender
    &__title
      font-size: 16px
      margin-bottom: 20px
    &__link
      min-width: 115px
      text-align: center
      font-size: 16px
      padding: 10px 25px
      margin-bottom: 20px
      border-radius: 8px
      background-color: #fff
      border: none
      color: $text-36
      box-shadow: 0 0 10px rgba(0,0,0,0.1)
      &:hover
        color: $text-36
        background-color: #fff
      &:active
        background-color: $text-36
        color: #fff

</style>
